export default {
  id_nav_title: "身分認證",
  basic_nav_title: "基礎資訊",
  work_nav_title: "工作資訊",
  other_nav_title: "其他資訊",
  other_Fill_in_the_information_below: "請認真填寫下方資料",
  other_emergency_contact: "緊急聯繫人",
  other_kinsfolk_contacts: "親屬聯繫人",
  other_other_contacts: "其他聯繫人",
  other_contacts_msg: "常聯繫的真實號碼有助於審核通過",
  other_relation: "關係",
  other_s_relation: "請選擇關係",
  other_s_name: "請選擇聯絡人",
  other_name: "姓名",
  other_p_name: "請輸入親屬姓名",
  other_phone: "手機號碼",
  other_p_phone: "請輸入手機號碼",
  other_phone_layout: "手機號碼格式錯誤",
  other_two_phone_msg: "請輸入不同的聯絡人資訊",
  other_rest_contacts: "其他聯絡人",
  other_p_rest_name: "請輸入聯絡人姓名",
  other_bank_title: "銀行卡資訊",
  other_bank_msg: "撥款帳戶存摺",
  other_bank: "銀行名稱",
  other_s_bank: "請選擇銀行名稱",
  other_bank_code: "銀行代號",
  other_s_bank_code: "請選擇銀行代號",
  other_s_bank_account_type: "請選擇銀行帳戶類型",
  other_s_query_bank: "查詢銀行",
  other_bank_type: "銀行帳戶類型",
  other_account: "帳號",
  other_card_num: "卡號",
  other_band_account: "銀行帳號",
  other_bank_branches: "銀行分行",
  other_p_bank_branches: "請輸入銀行分行",
  other_band_card: "銀行卡號",
  other_p_band_account: "請輸入銀行帳號",
  other_band_name: "銀行戶名",
  other_p_band_name: "請輸入銀行戶名",
  other_p_band_card: "請輸入銀行卡號",
  other_commit: "提交",
  other_toast_msg: "資料填寫完成",
  other_bank_realname: "請輸入姓名"
}